import { request } from './axios.js'

export let modelDetailsApi = (data) => request({ data, url: '/webapp/api/hqCar/modelDetails', })
export let modelParameterApi = (data) => request({ data, url: '/webapp/api/hqCar/modelParameter', })
export let modelListApi = (data) => request({ data, url: '/webapp/api/hqCar/modelList', })
export let addIcaurCusApi = (data) => request({ data, url: '/webapp/api/hqCar/add', })
export let modelPropParameterApi = (data) => request({ data, url: '/webapp/api/hqCar/modelPropParameter  ', })

export let newsListApi = (data) => request({ data, url: '/webapp/api/hqCar/newsList'})
export let newsDetailsApi = (data) => request({ data, url: '/webapp/api/hqCar/newsDetails'})
export let newsCreateApi = (data) => request({ data, url: '/webapp/api/hqCar/newsCreate'})
export let newsEditApi = (data) => request({ data, url: '/webapp/api/hqCar/newsEdit'})
export let newsDeleteApi = (data) => request({ data, url: '/webapp/api/hqCar/newsDelete'})

export let payStripeCusApi = (data) =>
  request({ data, url: '/webapp/api/pay/stripe', })
export let icaurCusUserInfoApi = (data) =>
  request({ data, url: '/webapp/api/hqCar/userInfo', })
